<div class="overlay_spinner z-1099" *ngIf="isSpinner">
    <img src="../../assets/img/loaders/loader.svg" alt="loader">
</div>
<div class="my-auto page page-h">
    <div class="main-signin-wrapper">
        <div class="main-card-signin d-md-flex wd-100p">
            <div class="wd-md-50p login d-none d-md-block page-signin-style p-5 text-white">
                <div class="my-auto authentication-pages">
                    <div class="text-center mt-5 pt-3">
                        <img id="nitro-image" name="nitro-image" src="../../../assets/img/blue-logo.png" width="140"
                            class=" m-0 mb-3 custm_node" alt="logo">
                        <h3 id="pni-title" name="pni-title">XEDGE</h3>
                    </div>
                </div>
            </div>
            <div class="p-5 wd-md-50p">
                <div class="main-signin-header">
                    <h4 id="header-text" name="header-text">Please sign in to continue to XEDGE</h4>

                    <form [formGroup]="loginForm" novalidate (ngSubmit)="Submit(loginForm.value)">
                        <div class="form-group">
                            <label id="label-username" name="label-username">Username</label>
                            <input class="form-control" id="username" name="username" placeholder="Enter your username"
                                type="text" formControlName="email" autocomplete="username">
                        </div>
                        <div class="form-group ipAddress_cls_head">
                            <label id="label-password" name="label-password">Password</label>
                            <input class="form-control" id="password" name="password" placeholder="Enter your password"
                                [type]="isTextFieldType1 ? 'text' : 'password'" formControlName="password" autocomplete="current-password">
                            <button type="button" class="eye_cio1" (click)="togglePasswordFieldType()" id="eye-btn"
                                name="eye-btn" ion-button item-right>
                                <mat-icon>{{ isTextFieldType1 ? 'visibility' : 'visibility_off'}}</mat-icon>
                            </button>
                        </div>
                        <button id="button-submit" name="button-submit" class="btn btn-main-primary btn-block"
                            [disabled]="!loginForm.valid">Sign In</button>
                    </form>

                    <button id="button-facebook" name="button-facebook" (click)="signInWithFacebook()"
                        class="btn btn-facebook btn-block">
                        <i class="fab fa-facebook mr-1"></i> Login with Facebook
                    </button>

                    <button id="button-ldap" name="button-ldap"
                        class="btn btn-ldap btn-block"
                        [disabled]="!loginForm.valid"
                        (click)="loginWithLdap(loginForm.value)">
                        <mat-icon class="btn-ldap-icon">domain</mat-icon>
                        Login with LDAP / AD
                    </button>

                </div>
            </div>
        </div>
    </div>
    <div class="py-0 text-center mt-2">
        <p id="copy-right" name="copy-right" class="mb-0">© 2026 VIAVI Solutions Inc.</p>
    </div>
    <div class="mt-0 text-center"><span id="version" name="version">Version
            {{versionNo}}</span></div>
</div>